// extracted by mini-css-extract-plugin
export default {"tableButton":"SaltingRoutesAllocationPage_tableButton__uAe9x","tableButtonGold":"SaltingRoutesAllocationPage_tableButtonGold__H9rJq"};